import ConceptoService from "@/api/services/finanzas/nomencladores/ConceptoService"
import Vue from "vue"

const state = () => ({
    conceptos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    CONCEPTOS: state => {
        return state.conceptos
    },
    CONCEPTOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_CONCEPTOS: (state, payload) => {
        state.conceptos = payload
    },

    SET_CONCEPTOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_CONCEPTO: (state, payload) => {
        state.conceptos.push(payload)
    },

    UPDATE_CONCEPTO: (state, payload) => {
        state.conceptos = state.conceptos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_CONCEPTO: (state, payload) => {
        state.conceptos = state.conceptos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_CONCEPTOS: async ({ commit, state }, { filter, conceptoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await ConceptoService.get({ filter, conceptoEstado, ...pagination })

            if (status === 200) {
                commit("SET_CONCEPTOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los conceptos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_CONCEPTOS: async ({ commit }) => {
        try {
            let { data, status } = await ConceptoService.getAll()
            if (status === 200) {
                commit("SET_CONCEPTOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_CONCEPTOS: async ({ commit }) => {
        try {
            let { data, status } = await ConceptoService.getAllRecords()
            if (status === 200) {
                commit("SET_CONCEPTOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los conceptos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_CONCEPTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ConceptoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_CONCEPTO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del concepto, inténtelo nuevamente"
            })
        }
    },

    ADD_CONCEPTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ConceptoService.post(payload)
            if (status === 201) {
                commit("ADD_CONCEPTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El concepto ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el concepto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_CONCEPTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ConceptoService.put(payload)
            if (status === 200) {
                commit("UPDATE_CONCEPTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El concepto ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el concepto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_CONCEPTO: async ({ commit }, payload) => {
        try {
            let { status, data } = await ConceptoService.delete(payload)
            if (status === 204) {
                commit("DELETE_CONCEPTO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El concepto ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_CONCEPTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El concepto ha sido deshabilitado  satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el historial del concepto, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
